<template lang="">
  <!-- <ProductDetailsHeader/> -->
  <div class="thankcover-success pb-5 mx-auto">
    <div class="container">
      <div class="row mx-auto">
        <div class="col-lg-10 col-md-8 col-sm-12 mx-auto">
      <div class="shadow-sm p-2 rounded mt-3 mb-4 product_details d-flex flex-wrap justify-content-between align-items-center gap-3 border-1 mx-0 w-100 thankyou_payment_success" v-if="journeyId && selectedPlanData">
        <div class="d-flex gap-2 align-items-center">
          <img :src="selectedPlanData[0].supportingData.insCompanyLogo" alt="" width="120" height="auto" class="bg-light p-2 rounded">
          <!-- <p class="mb-0 insurer_name">{{selectedPlanData[0].insuranceAndProducts.insuranceCompanyName}}</p> -->
        </div>
        <div>
          <p class="request_Id d-flex align-items-center gap-1 p-2 mb-0">
            <!-- <span>Journey ID: </span>
            <strong>{{this.journeyId}}</strong>
            <div class="copy_container">
              <img src="@/assets/images/copy-icon.svg" class="copy-icon " @click="copyToClipboard" v-if="!copySuccess"/>
              <img src="@/assets/images/accept.png" class="copy-icon-tick m-0 p-0" v-if="copySuccess" />
              <p class="copy_tooltip px-2 py-1 rounded">{{ !copySuccess ? 'Copy' : 'Copied' }}</p>
            </div> -->

            <div class="copy_CID mb-2">
              <JourneyIdContainer :journey-id="journeyId" label="JOURNEY ID :" />
            </div>

            <!-- <img src="@/assets/images/copy-icon.svg" width="20" height="20" class="copy-icon m-auto" @click="copyToClipboard" v-if="!copySuccess"/>
            <img src="@/assets/images/accept.png" width="20" height="20" class="copy-icon-tick m-0 p-0" v-if="copySuccess" /> -->
          </p>
        </div>
      </div>
      <div class="thank-you thankyou_payment_success rounded">
      <div class="text-center" >
        <img src="@/assets/images/car-inspection.png" v-if="this.carType=='Private Car'" class="m-auto inspection-image" />
        <img src="@/assets/images/bike-inspection.png" v-if="this.carType=='Two Wheeler'" class="m-auto inspection-image inspection-bike" />
        <!-- <h4 class="text-center text-success">Payment Successful !</h4> -->
        <!-- <h4 class="text-center text-black">
          Thank you for buying the {{carType}} policy.
        </h4> -->
        <!-- <CopyToClipboard :copyValue="applicationNumber" :checkValid="false" :hasLabel="true" :label="'Proposal Number'"  /> -->
        <h4 class="text-center text-black">
          An inspection has been triggered for your policy. The insurer will connect with you to take this forward.
        </h4>
        <div class="row mx-auto" v-if="applicationNumber && productCode && !productCode.startsWith('GO')">
          <div class="col-6 mx-auto">
            <div class="d-flex flex-wrap align-items-center justify-content-center gap-2 mt-2 p-3 bg-light shadow-sm rounded applicationNumber proposal_number">
              <strong class="applicationNumber">Proposal Number:</strong>
              <p class="mb-0" style="line-break: anywhere">{{applicationNumber}}</p>
            </div>
          </div>
        </div>
        <div class="row mx-auto" v-else>
          <div class="col-6 mx-auto">
            <div class="d-flex flex-wrap align-items-center justify-content-center gap-2 mt-2 p-3 bg-light shadow-sm rounded applicationNumber proposal_number">
              <strong class="applicationNumber">Policy Number</strong>
              <p class="mb-0" style="line-break: anywhere">{{policyNo}}</p>
            </div>
          </div>
        </div>
        
        <!-- <div class="row justify-content-center mt-4">
          <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div class="headingcards" style="width: 340px">
              <div class="mb-0 d-flex gap-2 align-items-center justify-content-center">
                <h3 class="alignment">Journey ID:</h3>
                <h3 class="alignment">{{journeyId}}</h3>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <div class="py-3 px-3 rounded mt-3 mb-4 product_details product_details01 border-1" v-if="selectedPlanData">
      <div class="product01">
        <p class="mb-2">
          <span>Plan Name</span>
          <strong>{{(selectedPlanData[0].insuranceAndProducts.policyTypeDesc).toUpperCase() || productName?.toUpperCase()}}</strong>
        </p>


        <p class="mb-2">
          <span>Final Premium</span>
          <div class="eye-icon d-flex gap-2 align-items-center">
            <strong clas>₹ {{premiumRound(manufacturerPayment)}}</strong>
            <img src="@/assets/images/eyeicon.svg" width="24" height="auto" @click="showBreakupmodal()"/>
            <p class="premium_breakup">Premium Breakup</p>
          </div>
        </p>


        <!-- <p class="mb-2">
          <span>Premium Amount</span>
          <strong>₹ {{formatIndianCurrency(manufacturerPayment)}}</strong>
        </p> -->
        <p class="mb-0">
          <span>Registration No.</span>
          <strong>{{registrationNo ? (registrationNo).toUpperCase() : 'NA'}}</strong>
        </p>
        <p class="mb-0">
          <span>Policy Status</span>
          <span class="pending_status px-0" style="font-size: 12px; line-break:anywhere">INSPECTION&nbsp;REQUIRED</span>
        </p>
        <p class="mt-2" v-if="customerName">
          <span>{{isCorporateJourney ? 'Company Name' : 'Customer Name'}}</span>
          <strong>{{ this.customerName.toUpperCase() }}</strong>
        </p>
        <p class="mt-2" v-if="inspectionLink">
            <span>Inspection Link</span>
            <a class="mb-0 pending_status text-decoration-none" :href="inspectionLink" target="_blank">CLICK HERE TO VISIT</a>
        </p>
        <p class="mb-0" v-if="inspectionvalidTill">
          <span>Inspection Validity</span>
          <strong>{{formatDateToMonthString(inspectionvalidTill)}}</strong>
        </p>
      </div>
    </div>
      
      <!-- <div class="py-3 px-3 rounded mt-3 mb-4 border-1" v-if="journeyId">
        <div class="product02">
          <p class="mb-2" v-if="inspectionLink">
            <strong><a class="inspection" :href="inspectionLink" target="_blank">Inspection Link</a></strong>
          </p>
          <p class="mb-2" v-if="inspectionvalidTill">
            <span>Inspection Validity</span>
            <strong>{{formatDateToMonthString(inspectionvalidTill)}}</strong>
          </p>
        </div>
      </div> -->
    </div>
    </div>
      </div>
    </div>
     <Disclaimer :page="'ThankYou'"/>
    <AmountBreakup v-if="this.openAmountBreakupflag" @emitClose="emitClose()" :selectedPlanData="selectedPlanData"/>
  </div>
    
  </template>
  <script>
import ProductDetailsHeader from '../productDetailsHeader/ProductDetailsHeader.vue';
import AmountBreakup from "@/modals/amountBreakup.vue";
import Disclaimer from "@/components/uiResuable/Disclaimer.vue"


export default {
    components:{
      ProductDetailsHeader,
      AmountBreakup,
      Disclaimer,
    },
  data(){
    return{
    policyNo: "",
    journeyId:"",
    inspectionLink:"",
    inspectionvalidTill:"",
    selectedPlanData: "",
    carType: "",
    registrationNo: "",
    manufacturerPayment: 0,
    applicationNumber: "",
    productCode: "",
    openAmountBreakupflag: false,
    customerName: "",
    isCorporateJourney: false,
    productName: ""
  };
},
  mounted(){
    if(sessionStorage.getItem("inspectionLink")) {
      this.inspectionLink = JSON.parse(sessionStorage.getItem("inspectionLink"));
    }
    if(sessionStorage.getItem("inspectionvalidTill")) {
      this.inspectionvalidTill = JSON.parse(sessionStorage.getItem("inspectionvalidTill"));
    }
    if(sessionStorage.getItem("journey_id")){
      this.journeyId = JSON.parse(sessionStorage.getItem("journey_id"));
    }
    let rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    this.selectedPlanData = rmData.RoleId !== "1" ? [JSON.parse(sessionStorage.getItem("selected_plan_data"))] : JSON.parse(sessionStorage.getItem("quoteSingleData"));
    this.carType = this.selectedPlanData[0].insuranceAndProducts?.productCode.includes('2W') ? 'Two Wheeler' : this.selectedPlanData[0].insuranceAndProducts?.productCode.includes('4W') ? 'Private Car' : "";
    let productNameFromUrl = JSON.parse(sessionStorage.getItem("payment-url-response"));
    this.productName = productNameFromUrl.productName;
    this.manufacturerPayment = this.selectedPlanData[0].productDetails.totalPremiumDetails[0].totalPremiumWithTax;
    let propsalReviewedObj = JSON.parse(sessionStorage.getItem("propsalDetails_review"));
    this.productCode = propsalReviewedObj?.quote_response.product_code 
    this.registrationNo = propsalReviewedObj.quote_request.quote_request_json.product.registrationDetails.registrationNumber;
    if(sessionStorage.getItem("payment-poll-url")){
      let data = JSON.parse(sessionStorage.getItem("payment-poll-url"))
      this.applicationNumber = data.applicationNumber;
      this.policyNo = data.policyNumber
    }
    this.isCorporateJourney = propsalReviewedObj?.quote_request?.quote_request_json?.personalInformation?.individualDetails[0].ownerBelongsToOrganizationFlag == true;
    if(propsalReviewedObj){
      this.customerName = this.isCorporateJourney ? propsalReviewedObj?.proposal?.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups?.corporateDetails?.fields?.nameOfCaompany?.input : propsalReviewedObj?.proposal?.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields?.fullName?.input;
    }
  },
  methods:{
    premiumRound(amount){
      var amount=Math.round(amount);
      return this.formatIndianCurrency(amount)
    },
    formatDateToMonthString(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace(/ /g, '-');
    },
    showBreakupmodal() {
      this.openAmountBreakupflag = true;
    },
    emitClose() {
      this.openAmountBreakupflag = false;
    },
    formatIndianCurrency(num) {
      let [integerPart, decimalPart] = num.toString().split("."); // Split into integer and decimal parts
      let lastThree = integerPart.slice(-3);
      let rest = integerPart.slice(0, -3);

      if (rest !== '') {
          rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      }
      let formattedDecimal = decimalPart ? "." + parseFloat("0." + decimalPart).toFixed(2).split(".")[1] : "";
      return rest !== '' ? rest + ',' + lastThree + formattedDecimal : lastThree + formattedDecimal;
    },
  },

  };

  </script>
  <style lang="scss">
 @import "../../assets/scss/components/Loaders.scss";
 .commonButton{
    background: $main-bg !important;
    color: $head-bg !important;
    border: 1px solid $main-bg !important;
    font-size: 12px;
    &:hover{
      background: $head-bg !important;
    border: 1px solid $main-bg !important;
    color: $main-bg !important;
  }
  }
  
 .thankyou_payment_success {
   margin: 0 auto;
   padding: 20px;
 }

 .copy_container{
    position: relative;
    img{
      width: 20px !important;
      border: none;
    }
    .copy-icon{
      transform: scale(1.1) !important;
      height: 16px !important;
    }
    .copy-icon-tick{
      transform: scale(0.9) !important;
      margin-left: auto !important;
    }
    .copy_tooltip{
      opacity: 0;
      visibility: hidden;
      position: absolute;
      top: -26px;
      left: -12px;
      font-size: 14px;
      color: $commonColor;
      background-color: $cardBackgroundDark;
    }
    &:hover{
      .copy_tooltip{
        visibility: visible;
        opacity: 1;
      }
    }
  }
 
 .inspection-image{
  display: inline-block;
  max-width: 420px;
  height: auto;
  padding-bottom: 32px;
 }
 .inspection-bike{
    max-width: 300px !important;
    height: auto;
 }
 
 .product_details01 {
   background-color: $gray-100;
 }
 .proposal_number{
  border: 1px solid $text-darkColor !important;
 }
 
 .product01 {
   p {
     display: flex;
     justify-content: space-between;
     align-items: center;
     
     span {
       font-size: 14px;
       color: $gray-600;
     }
     
     strong, a {
       font-size: 15px;
       font-weight: 600;
     }
   }
 }
 
 .pending_status {
   color: #ff9800 !important;
   font-weight: 600;
   border-radius: 4px;
   font-size: 12px !important;
 }

 .underwriting_status{
    color: #d10ac7 !important;
 }
 
 .success_status {
   color: #4caf50;
   font-weight: 600;
   border-radius: 4px;
   font-size: 12px !important;
 }
 
 .request_Id {
   background-color: #f8f9fa;
   border-radius: 4px;
   font-size: 14px;
 }
 
 .copy-icon {
   cursor: pointer;
 }
 .dark{
  .product_details{
    background-color: $commonColorDark !important;
  }
  .applicationNumber{
    background-color: $text-color !important;
    color: $text-darkColorTransparent !important;
  }
 }
 .inspection{
  word-break: break-all;
 }
</style>
  